var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconPath !== undefined)?_c('svg',{style:({
    width: _vm.iconPath.icon.width / 15,
    height: _vm.iconPath.icon.width / 15,
  })},_vm._l((_vm.iconPath.icon.paths),function(path,index){return _c('path',{key:index,staticStyle:{"height":"100%","width":"100%"},attrs:{"d":path,"fill":_vm.iconPath.attrs[index].fill}},[_vm._v("\n    "+_vm._s(_vm.iconPath.attrs[index].fill)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }